import { GET, POST, POSTNEW, download, UPLOADINGNEW, uploading, POSTFormData, EXPORTNEW, uploadingImg, DELETENEW, GETNEW } from '@/request/http'

// 保存参与活动记录
export const saveScanQrData = p => POST('/studentv2/activity-join/save/{activityType}', p)

// 统计每个档口的学生参与数量
export const getStallParticipationStudentNum = p => GET('/studentv2/activity-join/statistics/dumpling_vouchers', p)

// 获取title值
export const getStallTitle = p => GET('/studentv2/activity-provider/get/{id}', p)

// 根据类型获取所有档口
export const typeGetAllStallList = p => GET('/studentv2/activity-provider/findList/{activityType}', p)

// 根据类型获取所有档口数据
export const getAllStallData = p => POSTNEW('/studentv2/activity-query/page/{activityType}', p)

// 导出
export const exportAllStallData = p => EXPORTNEW('/studentv2/activity-query/export/dumpling_vouchers', p)



// WEBPACK FOOTER //
// ./src/api/modules/activity.js